import { render, staticRenderFns } from "./CommonFaults.vue?vue&type=template&id=1b9df877&scoped=true"
import script from "./CommonFaults.vue?vue&type=script&lang=js"
export * from "./CommonFaults.vue?vue&type=script&lang=js"
import style0 from "./CommonFaults.vue?vue&type=style&index=0&id=1b9df877&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9df877",
  null
  
)

export default component.exports